module.exports = __webpack_public_path__ + "static/media/Roman Commander.bc8ab656.jpg";